<div class="card">
  <div class="card-title text-center mt-3">
    <h3> CoronaVirus Updates for {{idData.state}} </h3>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class = 'chart-custom'>
        <canvas id="mychart" ></canvas>
      </div>
    </div>
    <div class="col-sm-6 mt-5">
        <div class="containter custom-padding">
          <div class="row">
            <div class="col-sm-6">Confirmed</div>
            <div class = 'col-sm-6'>{{idData.confirmed}} </div>
          </div>
          <div class="row">
            <div class="col-sm-6">Active</div>
            <div class = 'col-sm-6'>{{idData.active}} </div>
          </div>

          <div class="row">
            <div class="col-sm-6">Recovered</div>
            <div class = 'col-sm-6'>{{idData.recovered}} </div>
          </div>
          <div class="row">
            <div class="col-sm-6">Deaths</div>
            <div class = 'col-sm-6'>{{idData.deaths}} </div>
          </div>
        </div>

    </div>
  </div>
  <div class="card-text">
    <table class = 'table bg-light mt-5'>

      <th scope="col">#</th>
      <th scope="col">District Name</th>
      <th scope="col">Total Cases</th>
    <tbody>
      <tr *ngFor = "let Data of districtData; let i = index">
          <td>{{i+1}}</td>
          <td>{{Data.name}}</td>
          <td>{{Data.confirmed}}</td>
      </tr>
    </tbody>
    </table>
  </div>
</div>
<!-- {{districtData | json}} -->
<!-- {{idData | json}} -->
<!-- {{idData.active | json}} -->
